export const PaymentConst = {
    FETCH_PAYMENT_DATA_REQUEST: 'FETCH_PAYMENT_DATA_REQUEST',
    FETCH_PAYMENT_DATA_SUCCESS: 'FETCH_PAYMENT_DATA_SUCCESS',
    FETCH_PAYMENT_DATA_FAILURE: 'FETCH_PAYMENT_DATA_FAILURE',

    GENERATE_PAYMENT_LINK_REQUEST: 'GENERATE_PAYMENT_LINK_REQUEST',
    GENERATE_PAYMENT_LINK_SUCCESS: 'GENERATE_PAYMENT_LINK_SUCCESS',
    GENERATE_PAYMENT_LINK_FAILURE: 'GENERATE_PAYMENT_LINK_FAILURE',
    RESET_PAYMENT_LINK: 'RESET_PAYMENT_LINK',

    CLAIM_PAYOUT_REQUEST: 'CLAIM_PAYOUT_REQUEST',
    CLAIM_PAYOUT_SUCCESS: 'CLAIM_PAYOUT_SUCCESS',
    CLAIM_PAYOUT_FAILURE: 'CLAIM_PAYOUT_FAILURE',
    RESET_CLAIM_PAYOUT: 'RESET_CLAIM_PAYOUT',

    CONFIRM_CLAIM_CODE_REQUEST: 'CONFIRM_CLAIM_CODE_REQUEST',
    CONFIRM_CLAIM_CODE_SUCCESS: 'CONFIRM_CLAIM_CODE_SUCCESS',
    CONFIRM_CLAIM_CODE_FAILURE: 'CONFIRM_CLAIM_CODE_FAILURE',

    FETCH_BANKS_REQUEST: 'FETCH_BANKS_REQUEST',
    FETCH_BANKS_SUCCESS: 'FETCH_BANKS_SUCCESS',
    FETCH_BANKS_FAILURE: 'FETCH_BANKS_FAILURE',

    RESOLVE_BANK_REQUEST: 'RESOLVE_BANK_REQUEST',
    RESOLVE_BANK_SUCCESS: 'RESOLVE_BANK_SUCCESS',
    RESOLVE_BANK_FAILURE: 'RESOLVE_BANK_FAILURE',

    FETCH_VAS_SERVICES_REQUEST: 'FETCH_VAS_SERVICES_REQUEST',
    FETCH_VAS_SERVICES_SUCCESS: 'FETCH_VAS_SERVICES_SUCCESS',
    FETCH_VAS_SERVICES_FAILURE: 'FETCH_VAS_SERVICES_FAILURE',

    FETCH_VAS_CATEGORIES_REQUEST: 'FETCH_VAS_CATEGORIES_REQUEST',
    FETCH_VAS_CATEGORIES_SUCCESS: 'FETCH_VAS_CATEGORIES_SUCCESS',
    FETCH_VAS_CATEGORIES_FAILURE: 'FETCH_VAS_CATEGORIES_FAILURE',

    FETCH_VAS_PRODUCTS_REQUEST: 'FETCH_VAS_PRODUCTS_REQUEST',
    FETCH_VAS_PRODUCTS_SUCCESS: 'FETCH_VAS_PRODUCTS_SUCCESS',
    FETCH_VAS_PRODUCTS_FAILURE: 'FETCH_VAS_PRODUCTS_FAILURE',

    VERIFY_VAS_ENTITY_REQUEST: 'VERIFY_VAS_ENTITY_REQUEST',
    VERIFY_VAS_ENTITY_SUCCESS: 'VERIFY_VAS_ENTITY_SUCCESS',
    VERIFY_VAS_ENTITY_FAILURE: 'VERIFY_VAS_ENTITY_FAILURE',
};
